import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Redirect from './views/Redirect';
import FolderView from './views/FolderView';
import RelatedFiles from './views/RelatedFiles';
import RouteGuard from '@/Auth/RouteGuard';
import Logout from '@/Auth/Logout';

import store from './store';
// import { Auth } from 'aws-amplify';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: Redirect,
      meta: {
        requiresAuth: false
      }
    },
    {
      path:
        '/:orgSalesforceId([a-zA-Z0-9]{15,18})/:recordType(.{1,})/:recordTypeSalesforceId([a-zA-Z0-9]{15,18})',
      name: 'folder-view',
      component: FolderView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        '/related/:orgSalesforceId([a-zA-Z0-9]{15,18})/:recordType(.{1,})/:recordTypeSalesforceId([a-zA-Z0-9]{15,18})',
      name: 'folder-view',
      component: RelatedFiles,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: (to, from, next) => {
        Logout(to, from, next);
      }
    }
  ]
});

const setLastPage = (to) => {
  if (to.params.recordType) {
    window.localStorage.setItem(
      'lastRecord',
      JSON.stringify({
        route: {
          orgSalesforceId: to.params.orgSalesforceId,
          recordType: to.params.recordType,
          recordTypeSalesforceId: to.params.recordTypeSalesforceId,
          info: to.query.hasOwnProperty('info') ? to.query.info : ''
        },
        set: new Date()
      })
    );
  }
};

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    try {
      await store.dispatch('getLoginState');
      return next();
    } catch (e) {
      console.log('testststst');
      console.log(e);
      setLastPage(to);
      return next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
  }
  return next();
});

export default router;
